import axios from 'axios';
const API = process.env.REACT_APP_API_BASE || 'http://127.0.0.1:8000';
function h() {
  const a = JSON.parse(localStorage.getItem('zocs_auth') || 'null');
  return a ? { Authorization: `Bearer ${a.token}` } : {};
}
export async function browseInventory(f = {}) {
  const p = {};
  if (f.statuses?.length)   p.statuses       = f.statuses.join(',');
  if (f.gender)             p.gender         = f.gender;
  if (f.size)               p.size           = f.size;
  if (f.brand_name)         p.brand_name     = f.brand_name;
  if (f.category)           p.category       = f.category;
  if (f.price_tier)         p.price_tier     = f.price_tier;
  if (f.ownership_type)     p.ownership_type = f.ownership_type;
  if (f.condition)          p.condition      = f.condition;
  if (f.use_case_tag)       p.use_case_tag   = f.use_case_tag;
  if (f.style_tag)          p.style_tag      = f.style_tag;
  if (f.search)             p.search         = f.search;
  if (f.price_min != null)  p.price_min      = f.price_min;
  if (f.price_max != null)  p.price_max      = f.price_max;
  p.limit = f.limit || 300; p.offset = f.offset || 0;
  const r = await axios.get(`${API}/items/browse`, { headers: h(), params: p });
  return r.data;
}
export async function getItemTags() {
  const r = await axios.get(`${API}/items/tags`, { headers: h() });
  return r.data;
}
export async function getItemBrands() {
  const r = await axios.get(`${API}/items/brands`, { headers: h() });
  return r.data;
}
export async function getItemHistory(id, filters = {}) {
  const p = {};
  if (filters.event_type) p.event_type = filters.event_type;
  if (filters.date_from)  p.date_from  = filters.date_from;
  if (filters.date_to)    p.date_to    = filters.date_to;
  if (filters.limit != null)  p.limit  = filters.limit;
  if (filters.offset != null) p.offset = filters.offset;
  const r = await axios.get(`${API}/items/${encodeURIComponent(id)}/history`,
    { headers: h(), params: p });
  return r.data;
}
export async function getAvailableSizes(barcode) {
  const r = await axios.get(`${API}/items/${encodeURIComponent(barcode)}/available-sizes`, { headers: h() });
  return r.data;
}
